export default {"src":"/_next/static/media/technical_round.211ad324.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};